import React, { useState } from 'react';
import { Icon } from '../Icon';
import './GoalNameInput.css';

interface GoalNameInputProps {
  value: string;
  icon?: string;
  onChange: (value: string, icon?: string) => void;
  onNext: () => void;
  onBack: () => void;
}

// Подсказки для названий целей с кастомными иконками
const goalSuggestions = [
  { icon: 'goal-apartment', text: 'Квартира' },
  { icon: 'goal-car', text: 'Машина' },
  { icon: 'goal-plane', text: 'Отпуск' },
  { icon: 'goal-wedding', text: 'Свадьба' },
  { icon: 'goal-smartphone', text: 'Новый iPhone' },
  { icon: 'goal-laptop', text: 'MacBook' },
  { icon: 'goal-education', text: 'Образование' },
  { icon: 'goal-health', text: 'Здоровье' },
  { icon: 'goal-piggy-bank', text: 'Резервный фонд' },
  { icon: 'goal-investment', text: 'Инвестиции' },
  { icon: 'goal-gift', text: 'Подарок' },
  { icon: 'goal-travel', text: 'Путешествие' },
];

export const GoalNameInput: React.FC<GoalNameInputProps> = ({
  value,
  icon,
  onChange,
  onNext,
  onBack
}) => {
  const [showSuggestions, setShowSuggestions] = useState(true);

  const handleSubmit = () => {
    if (value.trim()) {
      onNext();
    }
  };

  return (
    <div className="goal-name-input step-content">
      <div className="goal-name-input__header">
        <button className="goal-name-input__back" onClick={onBack}>
          <Icon name="chevron_left" size={20} />
        </button>
        <div className="goal-name-input__header-content">
          <h2 className="goal-name-input__title">Название цели</h2>
          <p className="goal-name-input__subtitle">
            Как назовём вашу финансовую цель?
          </p>
        </div>
      </div>

      <div className="goal-name-input__input-wrapper">
          {icon && (
            <div className="goal-name-input__icon">
              <Icon name={icon} size={24} />
            </div>
          )}
          <input
          type="text"
          className={`goal-name-input__input ${icon ? 'goal-name-input__input--with-icon' : ''}`}
          placeholder="Например: Отпуск в Италии"
          value={value}
          onChange={(e) => {
            onChange(e.target.value, icon); // Сохраняем иконку при ручном вводе
            setShowSuggestions(e.target.value.length === 0);
          }}
          onFocus={() => setShowSuggestions(value.length === 0)}
          onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
        />
        {value && (
          <button
            className="goal-name-input__clear"
            onClick={() => {
              onChange('', undefined);
              setShowSuggestions(true);
            }}
          >
            ✕
          </button>
        )}
      </div>

      {showSuggestions && (
        <div className="goal-name-input__suggestions">
          <div className="goal-name-input__suggestions-title">Популярные цели:</div>
          <div className="goal-name-input__suggestions-grid">
            {goalSuggestions.map((suggestion) => (
              <button
                key={suggestion.text}
                className="goal-suggestion"
                onClick={() => {
                  onChange(suggestion.text, suggestion.icon);
                  setShowSuggestions(false);
                }}
              >
                <Icon name={suggestion.icon} size={20} />
                <span>{suggestion.text}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      <button
        className="goal-name-input__next"
        onClick={handleSubmit}
        disabled={!value.trim()}
      >
        Далее
      </button>
    </div>
  );
};

